import Path from "../../services/paths";
import BrandsActions from "../actions/brandsActions";
import utils from "../common/utils";

class BrandsMiddleware {
  static getBrands() {
    return dispatch => {
      dispatch(BrandsActions.brandsRequest());
      utils.get_token()
      .then(token=>{
      fetch(Path.GET_BRANDS, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      })
        .then(res => res.json())
        .then(res => {
          if (res.error) {
            // console.log("ERROR", res.error);
          }
          if (res.error) {
            // console.log("ERROR", res.error);
          } else {
            // console.log("SUCCESS", res);
            dispatch(BrandsActions.brandsSuccessul(res));
          }
        })
        .catch(error => {
          // console.log("IN CATCH");
          dispatch(BrandsActions.brandsFailed(error));
        });
      })
      .catch(error => {
        // console.log("IN CATCH");
        dispatch(BrandsActions.brandsFailed(error));
      });
    };
  }
}

export default BrandsMiddleware;
